import LogoPng from '../../../public/logo.png';
import LogoOnlyPng from '../../../public/logo-only.png';
import { useNavigate } from 'react-router-dom';

type Props = {
  small?: boolean;
};
const Logo = ({ small }: Props) => {
  const navigate = useNavigate();
  return (
    <img
      src={small ? LogoOnlyPng : LogoPng}
      alt="logo"
      style={{ cursor: 'pointer' }}
      onClick={() => navigate('/')}
    />
  );
};

export { Logo };
